import { useCallback } from 'react';

import { Filter, FilterResultStatus } from '@/components/filter';

import { AgentStatusFilter } from './agent-status';

import { useAgentsListStore } from '@/store/agents-list.store';

export const AgentSearchAndFilter = ({ agents }) => {
  const { query, setQuery, filters, reset } = useAgentsListStore();
  const handleClearQuery = useCallback(() => setQuery(''), [setQuery]);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-3">
        <Filter
          placeholder="Filter..."
          onFilter={setQuery}
          initialValue={query}
          onClear={handleClearQuery}
        />
        <AgentStatusFilter />
      </div>

      {(query || filters.status !== 'All') && (
        <FilterResultStatus
          resultsCount={agents.length}
          onReset={reset}
          message="No agents match your search"
        />
      )}
    </div>
  );
};
